import { createApiRef } from '@backstage/core-plugin-api';

import { ElementPath, TrackingData } from '../types';

export interface TrackingActions {
  navigate: true;
  dismiss: true;
  create: true;
  update: true;
  delete: true;
  'open-dialog': true;
  expand: true;
  collapse: true;
  copy: true;
}

export type Action = keyof TrackingActions extends never
  ? string
  : keyof TrackingActions & string;

export interface TrackingPages {}

export type PageId = keyof TrackingPages extends never
  ? string
  : keyof TrackingPages & string;

export interface Interaction {
  elementPath: ElementPath;
  type: 'click' | 'hover' | 'double-click' | 'scroll' | 'keypress';
  action: Action;
  data: TrackingData;
}

export interface Impression {
  elementPath: ElementPath;
  data: TrackingData;
}

export interface PageImpressionEvent {
  pageId: PageId;
  pageViewId: string;
  fromPageId: PageId | null;
  fromPageViewId: string | null;
  data: TrackingData;
}

export interface TrackingApi {
  trackInteraction(interaction: Interaction): void;
  trackImpression(impression: Impression): void;
  trackPageImpression(event: PageImpressionEvent): void;
}

export const trackingApiRef = createApiRef<TrackingApi>({
  id: 'confidence.tracking',
});
